import { render, staticRenderFns } from "./MultiswitchSingle.vue?vue&type=template&id=24916d25&scoped=true&"
import script from "./MultiswitchSingle.vue?vue&type=script&lang=js&"
export * from "./MultiswitchSingle.vue?vue&type=script&lang=js&"
import style0 from "./MultiswitchSingle.vue?vue&type=style&index=0&id=24916d25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24916d25",
  null
  
)

export default component.exports